// extracted by mini-css-extract-plugin
export var deleteModal = "_er-0";